<template>
  <div id="app">
    <div class="header">
      <div class="default-img">
        <img src="//cbshowhot.cdn.changbaimg.com/-/f40b3d4c100c8319/default404.png">
      </div>
      <div class="default-txt">啊哦，这个作品走丢了</div>
    </div>

    <section class="hot-area">
      <div class="hot-title">以下内容同样精彩</div>
      <div class="hot-content">
        <ul>
          <li class="hot-list" v-for="(item, index) in list" :key="index" v-if="index % 2 == 0">
            <div class="clip-btn" @click="goWorkPage(item.work.workid)" :data-clipboard-text="item.work.deeplink">
              <div class="hot-cover">
                <img :src="item.work.workphoto">
                <div class="hot-open-icon">打开APP</div>
                <div class="hot-play-num">{{ item.work.listen_num }}</div>
                <div class="hot-duration">{{ item.work.audioDuration | formateDuration }}</div>
                <div class="feed-mask-up"><img src="//cbshowhot.cdn.changbaimg.com/-/8a36ac360e511619/feed-mask-up.png"></div>
                <div class="feed-mask-down"><img src="//cbshowhot.cdn.changbaimg.com/-/89f3d520e330dcce/feed-mask.png"></div>
              </div>
              <div class="hot-des">
                {{ item.work.title }}
              </div>
              <div class="hot-userinfo">
                <div class="hot-avatar">
                  <img :src="item.work.user.headphoto | formatePhoto">
                </div>
                <div class="hot-nickname">{{ item.work.user.nickname }}</div>
              </div>
            </div>
          </li>
        </ul>
        <ul>
          <li class="hot-list" v-for="(item, index) in list" :key="index" v-if="index % 2 == 1">
            <div class="clip-btn" @click="goWorkPage(item.work.workid)" :data-clipboard-text="item.work.deeplink">
              <div class="hot-cover">
                <img :src="item.work.workphoto">
                <div class="hot-open-icon">打开APP</div>
                <div class="hot-play-num">{{ item.work.listen_num }}</div>
                <div class="hot-duration">{{ item.work.audioDuration | formateDuration }}</div>
                <div class="feed-mask-up"><img src="//cbshowhot.cdn.changbaimg.com/-/8a36ac360e511619/feed-mask-up.png"></div>
                <div class="feed-mask-down"><img src="//cbshowhot.cdn.changbaimg.com/-/89f3d520e330dcce/feed-mask.png"></div>
              </div>
              <div class="hot-des">
                {{ item.work.title }}
              </div>
              <div class="hot-userinfo">
                <div class="hot-avatar">
                  <img :src="item.work.user.headphoto | formatePhoto">
                </div>
                <div class="hot-nickname">{{ item.work.user.nickname }}</div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </section>

    <div class="fix-btn" @click="fixBtn">
      打开唱吧 发现更多精彩
    </div>

    <div class="swiper-container open-top">
      <div class="swiper-wrapper">

        <div class="swiper-slide" v-for="(item, index) in topDataList" :key="index">

          <div class="open-div1" v-if="item.type == 1">
            <div class="logo-icon">
              <img :src="item.logo_img_url">
            </div>
            <button class="clip-btn top-btn shake" :data-clipboard-text="item.jump_url">立即打开</button>
          </div>

          <div class="open-recommend-work" v-if="item.type == 2">
            <div class="recommend-work-avatar">
              <img :src="item.cover_img">
              <div class="recommend-work-play-icon">
                <img src="//cbshowhot.cdn.changbaimg.com/-/d7a176190425d378/playbtn.png">
              </div>
            </div>
            <div class="recommend-work-title">{{ item.title }}</div>
            <div class="recommend-work-content">{{ item.nickname }}</div>
            <button class="clip-btn top-btn shake" :data-clipboard-text="item.jump_url">立即观看</button>
          </div>

          <div class="open-search" v-if="item.type == 3">
            <div class="cblogo">
              <img src="//cbshowhot.cdn.changbaimg.com/-/f4b07fe455f12285/chang-ba.png">
            </div>
            <div class="search-area">
              <div class="search-icon">
                <img src="//cbshowhot.cdn.changbaimg.com/-/b74a119390b9eab2/sou-suo-icon.png">
              </div>
              <div class="search-txt">{{ item.content }}</div>
            </div>
            <button class="clip-btn top-btn shake" :data-clipboard-text="item.jump_url">打开唱吧</button>
          </div>

          <div class="open-share" v-if="item.type == 4 && topDataShareInfo">
            <div class="share-avatar">
              <img :src="topDataShareInfo.headphoto">
            </div>
            <div class="share-title">{{ topDataShareInfo.nickname }}分享给你这个作品</div>
            <div class="share-content">{{ item.user_content }}</div>
            <button class="clip-btn top-btn shake" :data-clipboard-text="topDataShareInfo.deeplink">关注TA</button>
          </div>

          <div class="open-recommend-user" v-if="item.type == 5">
            <div class="recommend-user-avatar">
              <img :src="item.headphoto">
            </div>
            <div class="recommend-user-content">{{ item.nickname }}喊你来唱吧关注TA</div>
            <button class="clip-btn top-btn shake" :data-clipboard-text="item.jump_url">关注TA</button>
          </div>

          <div class="open-activity" v-if="item.type == 6">
            <div class="activity-icon">
              <img :src="item.activity_img_url">
            </div>
            <div class="activity-title">{{ item.activity_title }}</div>
            <div class="activity-content">{{ item.activity_subtitle }}</div>
            <button class="clip-btn top-btn shake" :data-clipboard-text="item.jump_url">前往参与</button>
          </div>
        </div>
      </div>
      <div class="swiper-pagination"></div>
    </div>

    <div id="mask" @click="handleMask">
      <div class="bubble-container">
        <div class="step">1</div>
        点击顶栏<br />的右上角
        <img src="//cb.cdn.changbaimg.com/images/officialwebsite/right.png" class="step-img" />
      </div>
      <div class="bubble-container">
        <div class="step">2</div>
        点击菜单中的<br />
        在<span class="ua-info">浏览器</span>
        中打开
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper';
import 'swiper/dist/css/swiper.min.css';
import $ from 'zepto';

export default {
  name: 'App',
  filters: {
    formatePhoto(photo) {
      return photo.replace(/.jpg/g, "_320_320.jpg")
    },
    formateDuration(duration) {
      let min = Math.floor(duration / 60),
        sec = Math.floor(duration - min * 60);
      if (min < 10) {
        min = '0' + min;
      }
      if (sec < 10) {
        sec = '0' + sec;
      }
      return min + ':' + sec;
    }
  },
  data() {
    return {
      list: [],
      topRecommend: {},
      maskNone: false,
      page: 1,
      loadLocked: false,
      topDataList: [],
      topDataShareInfo: {},
      shareid: this.commonObj.utils.getQueryStrFn('shareid')
    }
  },
  mounted() {
    this.getList();
    this.getItemList();
    this.copyLink();
    window.addEventListener("scroll", this.handleScroll, true);
  },
  methods: {
    async getList() {
      this.loadLocked = true;
      try {
        const { code, data } = await this.$fetch(
          '/api/activity/wapPlay2020/getRecommendList',
          { data: { type: 3, page: this.page, num: 4 } }
        )
        if (code == 1 && data.length > 0) {
          this.list = this.list.concat(data)
          this.page++
          this.loadLocked = false
        }
      } catch (e) {
        console.log(e)
        this.loadLocked = false
      }
    },
    async getItemList() {
      const { code, data } = await this.$fetch('/api/activity/wapPlay2020/getItemList', { data: { shareid: this.shareid } });
      if (code == 1) {
        let delIndex;
        if (data.shareInfo) {
          this.topDataList = data.list;
          this.topDataShareInfo = data.shareInfo;
        } else {
          for (let j = 0; j < data.list.length; j++) {
            if (data.list[j].type == 4) {
              delIndex = j;
              this.$delete(data.list, delIndex);
            }
          }
          this.topDataList = data.list;
        }
        this.$nextTick(() => {
          this.initSwiper();
        });
      }
    },
    copyLink() {
      const clipboard = new this.clipboard(".clip-btn");
      clipboard.on('success', function(e) {
        console.log(e);
      });

      clipboard.on('error', function(e) {
        console.log(e, 'error');
      });
    },
    goWorkPage(workid) {
      // eslint-disable-next-line no-undef
      _cbs.action('推荐作品(包括顶部条推荐)-点击');
      this.callApp('changba://?ac=playuserwork&tag=weixinwapopen&isneedcallback=1&workid=' + workid, $("#mask"), '');
    },
    goRecommendPage() {
      this.callApp('changba://?ac=timeline&index=0&tabname=recommend', $("#mask"), '');
    },
    fixBtn() {
      // eslint-disable-next-line no-undef
      _cbs.action('悬浮按钮-点击');
      this.goRecommendPage();
    },
    goApp(href) {
      this.callApp(href, $("#mask"), '');
    },
    handleMask() {
      $("#mask").hide();
    },
    handleScroll() {
      const top = document.body.scrollTop || document.documentElement.scrollTop || window.pageXOffset
      if (document.body.offsetHeight - top - window.innerHeight < 50) {
        if (!this.loadLocked) {
          this.getList();
        }
      }
    },
    initSwiper() {
      const _this = this;
      new Swiper('.swiper-container', {
        loop: true,
        observer: true,
        observeParents: true,
        passiveListeners: false,
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: false
        },
        pagination: {
          el: '.swiper-pagination'
        },
        on: {
          click: function() {
            setTimeout(() => {
              if (_this.topDataList[this.realIndex].type == 1) {
                // eslint-disable-next-line no-undef
                _cbs.action('顶部条-品牌语');
                if (_this.topDataList[this.realIndex].old_url) {
                  _this.goApp(_this.topDataList[this.realIndex].old_url);
                } else {
                  _this.goRecommendPage();
                }
              }
              else if (_this.topDataList[this.realIndex].type == 2) {
                // eslint-disable-next-line no-undef
                _cbs.action('顶部条-推荐作品');
                _this.goApp(_this.topDataList[this.realIndex].old_url)
              }
              else if (_this.topDataList[this.realIndex].type == 3) {
                // eslint-disable-next-line no-undef
                _cbs.action('顶部条-假搜索');
                _this.goApp(_this.topDataList[this.realIndex].old_url)
              }
              else if (_this.topDataList[this.realIndex].type == 4) {
                // eslint-disable-next-line no-undef
                _cbs.action('顶部条-分享用户');
                _this.goApp('changba://?ac=personalpage&tag=weixinwapopen&isneedcallback=1&userid=' + _this.topDataShareInfo.userid)
              }
              else if (_this.topDataList[this.realIndex].type == 5) {
                // eslint-disable-next-line no-undef
                _cbs.action('顶部条-推荐用户');
                _this.goApp(_this.topDataList[this.realIndex].old_url)
              }
              else if (_this.topDataList[this.realIndex].type == 6) {
                // eslint-disable-next-line no-undef
                _cbs.action('顶部条-活动');
                _this.goApp(_this.topDataList[this.realIndex].old_url)
              }
            }, 10)

          }
        }
      })
    }

  }
}
</script>

<style lang="scss"  root-value="37.5">

  #app {
    background: #161622;
  }

  .header {
    padding-top: 90px;
    padding-bottom: 20px;
  }

  .default-img {
    width: 120px;
    height: 120px;
    margin: 0 auto;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .default-txt {
    width: 100%;
    opacity: 0.6;
    font-size: 14px;
    color: #fff;
    text-align: center;
  }

  .hot-area {
    text-align: center;
  }

  .hot-title {
    display: inline-block;
    font-size: 18px;
    color: #fff;
    text-shadow: 0 2px 5px rgba(0, 0, 0, 0.08);
    background: url(//cbshowhot.cdn.changbaimg.com/-/057ef63b4b190305/title-left-icon.png) no-repeat,
     url(//cbshowhot.cdn.changbaimg.com/-/81ee64b7a87e94b8/title-right-icon.png) no-repeat;
    background-size: 17px 13px ,17px 13px;
    padding: 0 26px;
    background-position: left center, right center;
    margin: 50px 0 20px 0;
  }

  .hot-content {
    text-align: center;
    padding-bottom: 100px;

    ul {
      width: 172px;
      display: inline-block;
      vertical-align: top;
    }
  }

  .hot-content ul:nth-child(1) {
    margin-right: 5px;
  }

  .hot-content ul:nth-child(2) {
    margin-left: 5px;
  }

  .hot-list {
    background: rgba(255, 255, 255, .1);
    padding-bottom: 10px;
    margin-bottom: 10px;
    border-radius: 6px;
  }

  .hot-list a {
    width: 100%;
  }

  .hot-cover {
    width: 100%;
    min-height: 129px;
    position: relative;
    background: url(//cbshowhot.cdn.changbaimg.com/-/04f362ff514798b7/cover-default.png) no-repeat;
    background-size: 100% 129px;
    background-position: center center;
  }

  .hot-cover img {
    width: 100%;
    height: 100%;
    border-top-right-radius: 6px;
    border-top-left-radius: 6px;
    display: inherit;
  }

  .feed-mask-up {
    width: 100%;
    position: absolute;
    left: 0;
    top: 0;

    img {
      width: 100%;
      height: 40px;
    }
  }

  .border-radius {
    border-radius: 6px;
  }

  .feed-mask-down {
    width: 100%;
    position: absolute;
    left: 0;
    bottom: 0;
  }

  .feed-mask-down img {
    width: 100%;
    height: 40px;
    position: absolute;
    left: 0;
    bottom: 0;
  }

  .hot-open-icon {
    opacity: 0.8;
    font-size: 12px;
    background: rgba(255, 255, 255, 0.20);
    border-radius: 20px;
    position: absolute;
    top: 5px;
    right: 5px;
    padding: 3px 5px;
    color: #fff;
    z-index: 1;
  }

  .hot-play-num {
    background: url(//cbshowhot.cdn.changbaimg.com/-/5f1cc17d98680246/bo-fang-bt-xiao-@3x.png) no-repeat;
    background-size: 9px 10px;
    background-position: left center;
    padding-left: 14px;
    position: absolute;
    left: 10px;
    bottom: 10px;
    color: #fff;
    font-size: 10px;
    text-shadow: 0 1px 0 rgba(0, 0, 0, 0.20);
    z-index: 1;

  }

  .hot-duration {
    color: #fff;
    font-size: 10px;
    position: absolute;
    right: 10px;
    bottom: 10px;
    text-shadow: 0 1px 0 rgba(0, 0, 0, 0.20);
    z-index: 1;
  }

  .hot-des {
    font-size: 14px;
    color: #fff;
    opacity: .8;
    padding: 0 10px;
    margin-top: 16px;
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    max-height: 30px;
  }

  .hot-userinfo {
    text-align: left;
    padding: 0 10px;
    font-size: 12px;
  }

  .hot-avatar {
    width: 40px;
    height: 40px;
    display: inline-block;
    vertical-align: middle;
    transform: scale(.5);
    transform-origin: 0% center;
  }

  .hot-avatar img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
  }

  .hot-nickname {
    max-width: 88px;
    height: 20px;
    line-height: 20px;
    opacity: 0.4;
    font-size: 12px;
    color: #fff;
    display: inline-block;
    margin-left: -16px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    vertical-align: middle;
  }

  .fix-btn {
    width: 8.933333rem;
    font-size: .48rem;
    color: #fff;
    text-align: center;
    background-image: linear-gradient(-45deg, #ff3a66 0%, #ff5046 100%);
    border-radius: 8.933333rem;
    padding: .346667rem 0;
    position: fixed;
    left: 50%;
    bottom: .8rem;
    transform: translate(-50%, 0);
    z-index: 1;
  }

  .inline-block {
    display: inline-block;
  }

  .open-top.swiper-container {
    width: 375px;
    height: 56px;
    position: fixed;
    top: 0;
    left: 50%;
    transform: translate(-50%, 0);
    background-color: rgba(22, 22, 34, .8);
  }

  .swiper-pagination-bullet-active {
    background: rgba(255, 255, 255, 1);
  }

  .swiper-pagination-bullet {
    background: rgba(255, 255, 255, 0.5);
    width: 8px;
    height: 8px;
    border-radius: 50%;
    transform: scale(.5);
    transform-origin: 0% center;
  }

  .swiper-container-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet {
    margin: 0;
  }

  .swiper-container-horizontal > .swiper-pagination-bullets {
    bottom: -2px;
  }


  .open-div1,
  .open-activity,
  .open-recommend-user,
  .open-share,
  .open-recommend-work,
  .open-search {
    width: 100%;
    height: 56px;
    position: relative;
  }

  .logo-icon {
    width: auto;
    height: 24px;
    position: absolute;
    left: 15px;
    top: 50%;
    transform: translate(0, -50%);

    img {
      width: auto;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
    }
  }

  .top-btn {
    font-size: 26px;
    color: #fff;
    border: 0;
    padding: 12px 18px;
    border-radius: 34px;
    background-image: linear-gradient(-37deg, #ff0040 0%, #ff2222 100%);
    position: absolute;
    right: 15px;
    top: 15px;
    line-height: 1;
    transform: scale(0.5);
    transform-origin: 100% 0;
  }

  .activity-icon {
    width: 98px;
    height: 40px;
    position: absolute;
    left: 15px;
    top: 50%;
    transform: translate(0, -50%);

    img {
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
    }
  }

  .activity-title,
  .share-title,
  .recommend-work-title {
    opacity: 0.8;
    font-size: 12px;
    color: #fff;
    position: absolute;
    left: 58px;
    top: 14px;
    max-width: 210px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .activity-content,
  .share-content,
  .recommend-work-content {
    opacity: 0.4;
    font-size: 8px;
    color: #fff;
    position: absolute;
    left: 58px;
    bottom: 14px;
    max-width: 210px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .activity-title,
  .activity-content {
    left: 125px;
    max-width: 160px;

  }

  .recommend-user-avatar {
    width: 28px;
    height: 28px;
    position: absolute;
    left: 17px;
    top: 50%;
    transform: translate(0, -50%);
  }

  .recommend-user-avatar img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    position: absolute;
    left: 0;
    top: 0;
  }

  .recommend-user-content {
    background: url(//cbshowhot.cdn.changbaimg.com/-/ab57c88bdf50d5e2/tui-jian-yong-hu-bg.png) no-repeat;
    background-size: 100% 24px;
    opacity: 0.7;
    font-size: 12px;
    position: absolute;
    left: 46px;
    top: 50%;
    transform: translate(0 , -50%);
    padding: 4px  10px 4px  16px;
    color: #fff;
    max-width: 210px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .share-avatar {
    width: 36px;
    height: 36px;
    position: absolute;
    left: 15px;
    top: 50%;
    transform: translate(0, -50%);
  }

  .share-avatar img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    position: absolute;
    left: 0;
    top: 0;
  }

  .recommend-work-avatar {
    width: 36px;
    height: 36px;
    position: relative;
    left: 15px;
    top: 50%;
    transform: translate(0, -50%);
  }

  .recommend-work-avatar img {
    width: 100%;
    height: 100%;
    border-radius: 4px;
    position: absolute;
    left: 0;
    top: 0;
  }

  .recommend-work-play-icon {
    width: 7px;
    height: 9px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  .recommend-work-play-icon img {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
  }

  .cblogo {
    width: 48px;
    height: 24px;
    position: absolute;
    left: 15px;
    top: 50%;
    transform: translate(0, -50%);
  }

  .cblogo img {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
  }

  .search-area {
    width: 207px;
    height: 28px;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 100px;
    position: absolute;
    left: 73px;
    top: 50%;
    transform: translate(0, -50%);
  }

  .search-icon {
    width: 14px;
    height: 14px;
    position: absolute;
    left: 14px;
    top: 50%;
    transform: translate(0, -50%);
  }

  .search-icon img {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
  }

  .search-txt {
    opacity: 0.5;
    font-size: 12px;
    color: #fff;
    position: absolute;
    left: 37px;
    top: 50%;
    transform: translate(0, -50%);
    max-width: 160px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .shake {
    animation: shake infinite 6s 5s;
  }

  @-webkit-keyframes shake {
    from,
    to {
      -webkit-transform: translate3d(0, 0, 0) scale(0.5);
      transform: translate3d(0, 0, 0) scale(0.5);

    }

    15% {
      -webkit-transform: translate3d(0, 0, 0) scale(0.5);
      transform: translate3d(0, 0, 0) scale(0.5);
    }

    2%,
    6%,
    10%,
    14% {
      -webkit-transform: translate3d(-10px, 0, 0) scale(0.5);
      transform: translate3d(-10px, 0, 0) scale(0.5);
    }

    4%,
    8%,
    12% {
      -webkit-transform: translate3d(0, 0, 0) scale(0.5);
      transform: translate3d(0, 0, 0) scale(0.5);
    }
  }

  #mask {
    display: none;
    position: fixed;
    width: 100%;
    max-width: 10rem;
    height: 100%;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    background-color: rgba(0, 0, 0, 0.7);
    z-index: 2147483647;
  }

  .bubble-container {
    position: relative;
    display: -webkit-box;
    -webkit-box-align: center;
    -webkit-box-pack: center;
    width: 46.5%;
    height: 1.866667rem;
    margin: .96rem auto 0 auto;
    border-radius: 50%;
    line-height: .533333rem;
    font-size: .373333rem;
    color: #fff;
    text-align: center;
    background-color: #ff5046;
  }

  .step {
    position: absolute;
    top: .026667rem;
    left: -.053333rem;
    width: .666667rem;
    height: .666667rem;
    border-radius: 50%;
    line-height: .666667rem;
    text-align: center;
    color: #fd7555;
    font-weight: bold;
    font-family: 'Helvetica Neue'cursive;
    background-color: #fff;
  }

  .step-img {
    position: absolute;
    width: 1.946667rem;
    right: -.773333rem;
    top: -.24rem;
  }

  .none {
    display: none;
  }

</style>
